import React from 'react';
import './AboutUsPage.css';
import Image from "../../../assets/images/about_us_img.png";
import { useTranslation } from "react-i18next";


function TermsOfUsePage() {
    const { t } = useTranslation();
    return (
        <div className="about-us-page">
            <h1>{t('Terms of Use')} </h1>
            <p><b>{t('Effective Date:')}</b> {t('MAY 2025')}</p>
            <p>{t('Welcome to www.abougabal.gr (“we,” “us,” or “our”). By accessing or using')} <a href="https://abougabal.gr" target="_blank" rel="noopener noreferrer">https://abougabal.gr</a>
                {t('(the “Site”), you agree to be bound by these Terms of Use. If you do not agree with any part of these terms, please do not use our website.')}</p>
            <hr/>
            <p><b>1. {t('Use of the Site')}</b></p>
            <div>{t('You may use the Site for personal, non-commercial purposes only. You agree not to:')}</div>
            <ul>
                <li>{t('Reproduce, duplicate, copy, sell, or exploit any content for commercial purposes without our written consent.')}</li>
                <li>{t('Attempt to interfere with or compromise the security or functionality of the Site.')}</li>
                <li>{t('Use any automated system to access or collect data from the Site (e.g., bots, scrapers).')}</li>
            </ul>
            <hr />
            <p><b>2. {t('Intellectual Property')}</b></p>
            <p>{t('All content on this Site, including text, graphics, logos, and code, is the property of www.abougabal.gr or its content suppliers and is protected by applicable copyright and trademark laws.')}</p>
            <hr />
            <p><b>3. {t('Third-Party Links')}</b></p>
            <p>{t('Our Site may contain links to external websites that are not controlled by us. We are not responsible for the content or practices of any third-party sites.')}</p>
            <hr />
            <p><b>4. {t('Disclaimer')}</b></p>
            <p>{t('The Site is provided "as is" and "as available" without warranties of any kind, either express or implied. We make no representations or warranties regarding the accuracy or completeness of the content.')}</p>
            <hr />
            <p><b>5. {t('Limitation of Liability')}</b></p>
            <p>{t('To the maximum extent permitted by law, www.abougabal.gr shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of the Site.')}</p>
            <hr />
            <p><b>6. {t('Privacy')}</b></p>
            <p>{t('Please refer to our')} <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">{t('Privacy Policy')}</a> {t('for information on how we collect, use, and protect your data.')}</p>
            <hr />
            <p><b>7. {t('Modifications')}</b></p>
            <p>{t('We reserve the right to modify these Terms of Use at any time. Changes will be posted on this page, and your continued use of the Site constitutes acceptance of the updated terms.')}</p>
            <hr />
            <p><b>8. {t('Governing Law')}</b></p>
            <p>{t('These terms shall be governed by and construed in accordance with the laws of Greece, without regard to its conflict of law provisions.')}</p>
            <hr />
            <p>{t('If you have any questions about these Terms, please contact us at abougabal.mm@gmail.com')}</p>

        </div>

    );
}

export default TermsOfUsePage;
